import { IStorageProductBooking } from "../../storage/storageProductBooking";

export class StorageProductBookingResponse {
    items: IStorageProductBooking[];
    notValidAmountLines: string[];

}
